var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManSendingEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#man-sending-email_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.138 85.055c6.143-9.34.534-19.38 1.467-29.768C6.538 44.9 16.42 42.63 14.548 33.823 12.382 23.614 18.151 13.81 24.694 13.81c6.543 0 12.317 9.804 10.146 20.013-1.871 8.807 8.01 11.076 8.944 21.464.933 10.388-4.672 20.432 1.467 29.768 6.144 9.341 4.532 21.709 1.068 27.848a24.128 24.128 0 01-3.299 4.513c-9.822 10.628-26.835 10.628-36.657 0a24.132 24.132 0 01-3.298-4.513c-3.454-6.139-5.066-18.512 1.073-27.848z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.595 147.478h6.209V95.244a3.113 3.113 0 00-3.104-3.102 3.113 3.113 0 00-3.105 3.102v52.234z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.731 147.478h8.455v-52.23a4.237 4.237 0 00-4.228-4.224 4.237 4.237 0 00-4.227 4.225v52.229z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.959 133.39c-14.38 0-26.037-11.649-26.037-26.018 0-14.369 11.657-26.017 26.037-26.017 14.38 0 26.036 11.648 26.036 26.017S82.338 133.39 67.96 133.39z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.359 99.572c-1.367-5.495 1.984-11.057 7.484-12.423 5.5-1.365 11.066 1.983 12.432 7.48 1.366 5.495-1.984 11.057-7.484 12.422-5.5 1.366-11.066-1.983-12.432-7.479zM83.015 92a6.07 6.07 0 015.018-6.967 6.07 6.07 0 111.953 11.98 6.073 6.073 0 01-6.97-5.013z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.406 92.142a4.26 4.26 0 01-4.262-4.259 4.26 4.26 0 014.262-4.259 4.26 4.26 0 014.262 4.259 4.26 4.26 0 01-4.262 4.259z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.594 116.304c4.337.644 8.09 2.215 11.339 4.324.03-3.945.753-7.695 2.61-10.722 2.825 2.753 5.115 6.314 6.967 10.139.694-7.197 2.585-14.174 6.772-18.577 6.274 3.945 9.508 10.518 11.045 17.48 2.5-4.464 5.949-8.578 10.71-11.571 3.838 4.04 5.065 9.626 4.961 15.351 4.361-5.072 9.202-9.037 13.924-9.501 1.162 8.035-1.313 15.615-4.457 21.589-4.127 7.835-12.337 12.668-21.196 12.668h-20.506c-8.739 0-16.934-4.658-21.031-12.373-2.601-4.888-3.833-11.176-1.138-18.807z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.438 12.697C124.902 5.281 126.914 0 133.107 0c3.883 0 8.699 2.08 13.39 5.46.529-1.93 2.021-3.086 4.422-3.086 4.227 0 10.051 3.57 14.618 8.613 1.108-1.123 2.705-1.81 4.761-1.92 4.042-.23 8.943 1.825 13.2 5.161.37-.558 1.004-.908 1.877-.962 2.331-.13 5.485 1.94 7.052 4.623.1.17.184.329.269.493H126.2c-.19-2.334.225-4.289 1.238-5.685zM127.233 57.725c-1.238-3.62-.255-6.203 2.769-6.203 1.897 0 4.253 1.017 6.543 2.668.26-.943.988-1.506 2.161-1.506 2.066 0 4.911 1.745 7.142 4.204.539-.549 1.323-.883 2.326-.938 1.976-.11 4.367.893 6.448 2.523.179-.274.489-.443.913-.468 1.138-.065 2.68.947 3.444 2.259.049.085.089.16.134.24h-32.479c-.1-1.143.105-2.095.599-2.779zM52.323 30.327c.254-.035.509-.055.769-.055-.24-3.62 1.147-5.93 4.102-5.93 2.13 0 4.751 1.207 7.421 3.247-.764-7.022 1.682-11.59 7.217-11.59 4.466 0 10.12 2.967 15.705 7.815.49-2.758 2.136-4.409 4.901-4.409 4.856 0 11.758 5.102 17.293 12.303 0 0 0 .01.005 0 1.198-1.605 2.99-2.598 5.355-2.757 4.626-.325 10.366 2.608 15.456 7.385.39-.807 1.093-1.306 2.101-1.371 2.531-.175 6.014 2.459 8.04 5.984H48.265c-2.18-5.34-.454-10.019 4.058-10.622z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.622 170c-53.442 0-96.765-2.528-96.765-5.646 0-3.117 43.323-5.645 96.765-5.645s96.765 2.528 96.765 5.645c0 3.118-43.323 5.646-96.765 5.646z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.005 31.857L85.232 48.225 69.96 63.62l129.045-31.763z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.005 31.857L85.232 48.225l5.28 22.262 108.493-38.63z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.847 6.084L86.24 37.02a3.12 3.12 0 002.395 3.696l58.93 12.567a3.123 3.123 0 003.698-2.394l6.608-30.94a3.112 3.112 0 00-.499-2.433 3.137 3.137 0 00-1.901-1.262L96.545 3.685a3.126 3.126 0 00-2.25.374 3.127 3.127 0 00-1.448 2.025z",
    fill: "#51F0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.294 4.06l19.694 24.152a12.701 12.701 0 0015.546 3.316l27.843-14.013a3.137 3.137 0 00-1.902-1.262L96.545 3.685a3.126 3.126 0 00-2.25.374z",
    fill: "#B2FFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.005 31.857l-93.841 22.288-14.652 16.342 108.493-38.63z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.772 53.345l.252.43-10.442 6.114-.252-.43 10.442-6.114zM149.72 62.16l.253.43-3.755 2.2-.252-.431 3.754-2.198z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.005 31.857l-93.841 22.288 18.242 21.968 75.599-44.256z",
    fill: "#6EC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.488 84.072c.12 0 .245-.025.37-.07l15.286-6.049a.996.996 0 00.559-1.297.996.996 0 00-1.298-.558l-15.286 6.05a.996.996 0 00.37 1.924z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.387 75.315c.12 0 .245-.025.37-.07L82.966 72a.996.996 0 00.558-1.297.996.996 0 00-1.297-.558l-8.21 3.246a.996.996 0 00.37 1.925z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.387 75.315c.12 0 .245-.025.37-.07L82.966 72a.996.996 0 00.558-1.297.996.996 0 00-1.297-.558l-8.21 3.246a.996.996 0 00.37 1.925z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.555 83.922c.12 0 .244-.024.37-.07l14.906-5.899a.995.995 0 00.559-1.297.996.996 0 00-1.297-.558l-14.907 5.9a.996.996 0 00.369 1.924z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.586 38.97a137.14 137.14 0 00-3.688 7.805c-1.143 2.643-2.231 5.32-3.164 8.123l-.34 1.063c-.054.19-.144.498-.194.718-.045.23-.095.469-.125.678-.13.868-.155 1.656-.17 2.424-.025 1.536.08 3.002.21 4.463.28 2.913.734 5.745 1.357 8.588l2.735-.304c.035-2.808.06-5.646.16-8.413.05-1.382.13-2.758.27-4.06.07-.643.174-1.276.294-1.805.03-.14.065-.25.1-.364.04-.125.055-.155.11-.3l.374-.942c1.043-2.523 2.216-5.067 3.413-7.6l3.624-7.596-4.966-2.478z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.167 71.685l1.277 2.388-4.082 1.137s-.779-1.92.15-3.436l2.655-.09zM37.012 77.514l-3.753.295-1.892-2.599 4.078-1.137 1.567 3.441z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.998 22.232s.998 1.536 1.887 2.195c-.414.583-1.333.538-1.333.538l-.554-2.733z",
    fill: "#FF9090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.509 25.809c.524 2.678 1.053 7.59-.824 9.38 0 0 .734 2.718 5.72 2.718 5.48 0 2.62-2.718 2.62-2.718-2.99-.713-2.915-2.932-2.39-5.012l-5.126-4.368z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.932 36.88c-.394-1.311-.833-2.818.07-3.286.993-.519 6.418-1.048 8.29-.075 1.871.972 1.342 3.636 1.342 3.636l-9.702-.275z",
    fill: "#00217C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.418 161.253c.374 0 .739-.06.878-.245.06-.079.105-.209-.005-.414a.416.416 0 00-.274-.204c-.54-.125-1.547.569-1.592.598-.03.02-.04.055-.035.09.005.035.03.06.065.07.195.045.589.105.963.105zm.46-.698c.04 0 .074.005.104.01a.237.237 0 01.16.114c.08.145.03.205.015.225-.155.204-.909.209-1.453.114.32-.189.839-.463 1.173-.463z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.485 161.153c.015 0 .03-.005.04-.01.38-.204 1.113-1.007 1.038-1.416-.015-.075-.07-.205-.274-.23a.49.49 0 00-.37.11c-.424.349-.514 1.407-.519 1.451 0 .03.015.06.04.08.01.01.025.015.045.015zm.739-1.486h.04c.114.015.124.065.124.09.045.244-.419.848-.798 1.132.045-.309.16-.923.434-1.147a.32.32 0 01.2-.075zM55.437 161.253c.47 0 .923-.065 1.078-.274.055-.075.095-.2-.005-.379a.447.447 0 00-.274-.205c-.61-.164-1.892.564-1.947.594-.03.02-.05.055-.04.09a.085.085 0 00.07.069c.225.05.679.105 1.118.105zm.579-.708c.06 0 .12.005.17.02.08.02.134.06.17.12.06.109.04.159.014.189-.164.229-1.093.239-1.776.145.339-.17.993-.474 1.422-.474z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33 161.154c.01 0 .024 0 .034-.005.444-.2 1.318-.993 1.253-1.407-.015-.099-.085-.219-.325-.244a.623.623 0 00-.479.15c-.464.384-.564 1.371-.569 1.411-.005.03.01.06.035.08.015.01.03.015.05.015zm.892-1.487h.05c.155.015.165.08.17.1.04.25-.554.873-1.008 1.142.045-.289.18-.877.484-1.132a.476.476 0 01.304-.11z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.297 161.063h3.668l.364-8.483h-3.668l-.364 8.483zM28.283 161.063h3.668l1.842-8.483h-3.668l-1.842 8.483z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21 160.64h-4.117c-.15 0-.28.104-.314.249l-.724 3.257a.54.54 0 00.539.653c1.437-.025 2.136-.11 3.947-.11 1.113 0 3.41.115 4.951.115 1.508 0 1.742-1.521 1.108-1.661-2.825-.618-3.888-1.471-4.79-2.279a.917.917 0 00-.6-.224zM53.94 160.64h-4.003c-.15 0-.28.104-.314.249l-.724 3.257a.533.533 0 00.53.653c1.442-.025 3.533-.11 5.344-.11 2.121 0 3.958.115 6.443.115 1.508 0 1.922-1.521 1.293-1.661-2.87-.628-5.21-.693-7.69-2.219-.265-.165-.565-.284-.879-.284z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.707 41.622a85.764 85.764 0 009.138-1.212 61.88 61.88 0 004.542-1.022c1.517-.404 3.04-.868 4.571-1.506.385-.16.774-.334 1.158-.519.484-.239.888-.488 1.243-.723.718-.474 1.337-.967 1.951-1.456 1.223-.977 2.356-1.995 3.479-3.017 2.23-2.065 4.347-4.2 6.388-6.444l-1.837-2.05-7.241 5.202c-1.193.863-2.4 1.701-3.589 2.494a29.9 29.9 0 01-1.746 1.077c-.28.16-.53.274-.72.354-.293.115-.598.23-.912.334-2.536.843-5.4 1.387-8.25 1.846-2.85.448-5.794.822-8.639 1.117l.464 5.525z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.118 36.017c-3.439.788-6.912 10.827-6.912 10.827l7.072 5.072s1.976-4.678 3.917-8.768c2.047-4.284-.564-7.934-4.077-7.131z",
    fill: "#0137A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.104 41.503l1.403 3.137c-1.453 3.132-2.78 6.234-3.134 7.062.05-3.706.753-8.304 1.731-10.2z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.104 41.503l1.403 3.137c-1.453 3.132-2.78 6.234-3.134 7.062.05-3.706.753-8.304 1.731-10.2z",
    fill: "#00217C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66 36.206s3.902 4.404.214 31.668H40.265c-.135-3.007 1.757-17.684-1.148-31.857 0 0 3.364-.674 6.563-.828 2.505-.12 6.134-.2 8.335 0 2.91.264 5.644 1.017 5.644 1.017z",
    fill: "#0137A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.112 41.503c.13 1.032.23 2.254.294 3.695-1.622-.503-3.638-1.311-5.46-2.563l5.166-1.132z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.112 41.503c.13 1.032.23 2.254.294 3.695-1.622-.503-3.638-1.311-5.46-2.563l5.166-1.132z",
    fill: "#00217C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.722 42.037c2.625 2.324 12.647 2.09 12.647 2.09l.33-9.68s-5.68.832-10.217.737c-5.6-.11-5.64 4.304-2.76 6.853z",
    fill: "#0137A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.26 23.719l2.515-2.938 2.685 2.973s-1.652 2.782-4.287 2.343l-.913-2.378z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.329 17.355l.968 3.835-1.837 2.564-2.685-2.972 3.554-3.427z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33 152.585l-.19 4.374H50.47l.19-4.374h3.668zM30.124 152.585h3.668l-.953 4.374H29.17l.953-4.374z",
    fill: "#CE6F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.118 18.093c3.29-1.52 4.327-8.148-5.13-6.508 0 0 1.427 1.581-1.472 2.579-2.895.997-.47 7.196 6.602 3.93z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.977 23.086c.943 3.51 1.312 5.616 3.483 7.077 3.264 2.194 7.326-.325 7.451-4.045.115-3.351-1.447-8.533-5.215-9.24-3.718-.7-6.663 2.697-5.72 6.208z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.117 13.376c-2.24 1.251-5.275 2-4.97 3.77.374 2.17-1.837.813-1.323 4.044.335 2.11 4.232 8.503 6.972 8.19 4.123-.47 3.599-6.758 3.614-10.065.005-1.95.1-8.398-4.292-5.94z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.904 16.174c.998.234 2.32 5.984-1.547 6.513-4.452.603 1.547-6.513 1.547-6.513z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 18.213c1.222.11 3.982-1.361 3.652-3.575 0 0-1.756 2.588-3.653 3.575z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.987 23.146c.384.872 1.108 1.556 1.807 1.925 1.053.548 1.647-.255 1.407-1.307-.215-.947-1.023-2.379-2.106-2.494-1.068-.12-1.547.878-1.108 1.876z",
    fill: "#FFAAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.498 19.086c-.739-.379-2.425-1.232-2.89-3.65.005-.005-1.646 4.593 2.89 3.65z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33 19.036c.37-.215 1.208-.709 2.39-.235 0 0-1.536-1.99-2.39.235z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.922 67.875s-4.162 27.998-6.443 38.49c-2.5 11.486-11.923 49.752-11.923 49.752H27.84s6.213-37.334 7.64-48.709C37.026 95.065 40.27 67.88 40.27 67.88h12.652v-.005z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.624 153.638c.03 0-.694 2.578-.694 2.578h-7.556l.14-2.299 8.11-.279z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.624 153.638c.03 0-.694 2.578-.694 2.578h-7.556l.14-2.299 8.11-.279z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.292 77.849c-4.811.942-4.302 18.871-3.723 28.092 1.387-6.518 3.419-19.06 4.806-27.962-.32-.16-.679-.21-1.083-.13z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.292 77.849c-4.811.942-4.302 18.871-3.723 28.092 1.387-6.518 3.419-19.06 4.806-27.962-.32-.16-.679-.21-1.083-.13z",
    fill: "#EDF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.88 67.875s.503 27.394.104 38.565c-.414 11.62-4.477 49.672-4.477 49.672h-6.213s-.23-37.374-.504-48.784c-.3-12.443-1.807-39.453-1.807-39.453H59.88z",
    fill: "#B4DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7 153.638c.03 0-.35 2.578-.35 2.578h-7.556l-.204-2.299 8.11-.279z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.7 153.638c.03 0-.35 2.578-.35 2.578h-7.556l-.204-2.299 8.11-.279z",
    fill: "#008BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "man-sending-email_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 199.005 0)",
    fill: "#fff",
    d: "M0 0h199.005v170H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/man-sending-email.44386577.svg";
export { SvgManSendingEmail as ReactComponent };